<div class="px-4 py-5 my-5 text-center">
  <h1 style="color: var(--primary-color)" class="display-4 ">Responsabilidades en</h1>
  <h2 style="color: var(--primary-color)" class="display-6 fw-bold ">Seguridad y Salud en el Trabajo</h2>
  <div class="col-lg-6 mx-auto text-start">
    <p class=" lead mb-4 text-secondary text-center fs-4">
      <span class="fw-bold text-center">Cubrimos los requerimientos de nuestros cliente</span> <br>
      con profesionales en Medicina y Salud Ocupacional, garantizando los objetivos empresariales, las normativas legales vigentes, y la salud y seguridad del talento Humano.
    </p>
    <p></p>
  </div>
</div>
